import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { PricingRuleAction } from './pricingRule.action';
import { pricingRuleInitialState } from './pricingRule.constant';

export const pricingRuleReducer = reducerWithInitialState(pricingRuleInitialState)
  .case(PricingRuleAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(PricingRuleAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(PricingRuleAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(PricingRuleAction.destroy, () => ({
    ...pricingRuleInitialState,
  }));
